export const INCOMEBRACKET_MAININCOME_GET = 'INCOMEBRACKET_MAININCOME_GET';
export const INCOMEBRACKET_MAININCOME_BEGIN_FETCH =
  'INCOMEBRACKET_MAININCOME_BEGIN_FETCH';
export const INCOMEBRACKET_MAININCOME_END_FETCH =
  'INCOMEBRACKET_MAININCOME_END_FETCH';

export const INCOMEBRACKET_GET = 'INCOMEBRACKET_GET';
export const INCOMEBRACKET_BEGIN_FETCH = 'INCOMEBRACKET_BEGIN_FETCH';
export const INCOMEBRACKET_END_FETCH = 'INCOMEBRACKET_END_FETCH';

export const INCOMEBRACKET_POST_UPDATECREATE =
  'INCOMEBRACKET_POST_UPDATECREATE';
export const INCOMEBRACKET_BEGIN_UPDATE_FETCH =
  'INCOMEBRACKET_BEGIN_UPDATE_FETCH';
export const INCOMEBRACKET_END_UPDATE_FETCH = 'INCOMEBRACKET_END_UPDATE_FETCH';
export const INCOMEBRACKET_BEGIN_CREATE_FETCH =
  'INCOMEBRACKET_BEGIN_CREATE_FETCH';
export const INCOMEBRACKET_END_CREATE_FETCH = 'INCOMEBRACKET_END_CREATE_FETCH';

export const INCOMEBRACKET_POST_CANCREATE = 'INCOMEBRACKET_POST_CANCREATE';

export const INCOMEBRACKET_CREATE = 'INCOMEBRACKET_CREATE';
export const INCOMEBRACKET_ERROR = 'INCOMEBRACKET_ERROR';



// WEBPACK FOOTER //
// ./src/pages/incomebracket/state/types.js